module.exports = __webpack_public_path__ + "static/media/drag-city-combined-iphonex3.a8bd505e.png";